export const PERMISSION = {
  SEARCH_AUTHORIZATION: 'SEARCH_AUTHORIZATION',
  CREATE_AUTHORIZATION: 'CREATE_AUTHORIZATION',
  VIEW_DETAIL_AUTHORIZATION: 'VIEW_DETAIL_AUTHORIZATION',
  UPDATE_AUTHORIZATION: 'UPDATE_AUTHORIZATION',

  REJECT_DCS: 'REJECT_DCS',
  APPROVE_DCS: 'APPROVE_DCS',
  SEND_APPROVE_DCS: 'SEND_APPROVE_DCS',
  CREATE_DCS: 'CREATE_DCS',
  SEARCH_DCS: 'SEARCH_DCS',
  VIEW_DETAIL_DCS: 'VIEW_DETAIL_DCS',
  UPDATE_DCS: 'UPDATE_DCS',
  SEARCH_APPROVE_DCS: 'SEARCH_APPROVE_DCS',
  SHARE_DCS: 'SHARE_DCS',
  PAUSE_DCS: 'PAUSE_DCS',
  RESUME_DCS: 'RESUME_DCS',

  SEARCH_USERS: 'SEARCH_USERS',
  VIEW_DETAIL_USERS: 'VIEW_DETAIL_USERS',
  CREATE_INTERNAL_USERS: 'CREATE_INTERNAL_USERS',
  UPDATE_USERS: 'UPDATE_USERS',
  ACTIVE_INACTIVE_USERS: 'ACTIVE_INACTIVE_USERS',
};

export const ROLE = {
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
};

export const checkHasAnyRole = (roleList = [], role = []) => {
  return roleList.find((item) => role.find((r) => r === item));
};

export const checkHasAnyPermission = (
  permissionsList = [],
  permission = []
) => {
  return permissionsList.find((item) => permission.find((r) => r === item));
};

export const checkHasAnyRoleOrPermission = (
  permissionsList,
  roleList,
  role,
  permission
) => {
  if (!role && !permission) return true;

  let match;
  if (role) {
    match = checkHasAnyRole(roleList, role);
  }

  return match || checkHasAnyPermission(permissionsList, permission);
};
